import { Injectable } from "@angular/core";

import { AbstractParser } from "../../parser";
import { PaymentType } from "src/app/ui/models/domains/pbm/Benefit/payment-type";

@Injectable()
export class PaymentTypeParser extends AbstractParser<PaymentType[]> {
  parse(payload: any): PaymentType[] {
    const productTypes: Array<PaymentType> = [];

    payload.forEach((type) => {
      const productType = new PaymentType();
      productType.setKey(type.Key);
      productType.setValue(type.Value);
      productTypes.push(productType);
    });

    return productTypes;
  }
}
